<script lang="ts" setup>
import { useTranslation } from '@hfc/ui-core';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

const { getBaseUrl } = useUrlHelper();
const { t } = useTranslation();
</script>

<template>
  <div class="md:px-12">
    <h4 class="text-blue text-xl font-bold pb-6 md:pb-10">{{ t('coveredCalifornia.questions.whenCanEnroll.tab') }}</h4>
    <p class="text-gray-500 text-left pb-7" v-html="t('coveredCalifornia.questions.whenCanEnroll.p1', { lifeEventsUrl: getBaseUrl('/covered-california/life-events') })"></p>
    <p class="text-gray-500 text-left pb-7">{{ t('coveredCalifornia.questions.whenCanEnroll.p2') }}</p>
    <p class="text-gray-500 text-left pb-7">{{ t('coveredCalifornia.questions.whenCanEnroll.p3') }}</p>
  </div>
</template>
